import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom";
import Layout from "../Layout";
import Table from "antd/lib/table";
import Loader from "../loader";
import Add from "../../assets/images/Add.svg";
import { getuserroleandmenu } from '../../Redux/Actions/UsersActions';
//import Eyeicon from "../../assets/images/eye-icon.png";
import VisibilityIcon from '@mui/icons-material/Visibility';
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { fetchAllVersiondata, fetchUserRoledata } from "../../Redux/Api/fetch.api";
import { getallversionsummary, updateapprovedsummary } from '../../Redux/Actions/VersionActions';
import { Tooltip, Switch } from 'antd';
import axios from "axios";
import * as url from "../../api/uri_helper"; 
import NotAuthorised from "../Authentication/NotAuthorised";
import { useTranslation } from "react-i18next";
import Title from "../Title";
import { Breadcrumb } from "antd";
import PlayArrowIcon from '@mui/icons-material/LaptopMac';// for Active
import NewReleasesIcon from '@mui/icons-material/NewReleases'; // for New
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // for Resolved
import ReplayIcon from '@mui/icons-material/Replay'; // for ReOpen
import BugReportIcon from '@mui/icons-material/BugReport'; // for QA
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'; // for Deployed
import { Deblur } from "@mui/icons-material";

const VersionIndex = () => {
    const { t } = useTranslation('version');
    const dispatch = useDispatch();
    const { REACT_APP_DEFAULT_PAGESIZE } = process.env;
    const [loading, setLoading] = useState(false);
    const allUserTypes = useSelector((state) => state.allUserdata.users);
    const [table, setTable] = useState([]);
    const [pageSize, setPagesize] = useState(REACT_APP_DEFAULT_PAGESIZE)
    const [totalCount, setTotalCount] = useState()
    const [options, setOptions] = useState({ pagination: { current: 1 }, pageSize: pageSize });
    const [totalIndex, setCurrentIndex] = useState()
    const [pageData, setPageData] = useState({});
    const [total, setTotal] = useState()
    let history = useHistory();
    const { REACT_APP_WORLITEM_LINK } = process.env;
    const loggedUserId = localStorage.getItem('UserId')
   // const [roleName, setRoleName] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const showPagination = totalCount > REACT_APP_DEFAULT_PAGESIZE;
    const pageIndex = 1;
   const [commingCompanyId, setCommingCompanyId] = useState();

    useEffect(() => {              
        getRoleDetails();
    }, []);
   
    const getVersionDetails = () => {      
      
        setLoading(true)
        var userId = parseInt(loggedUserId);
        // var companyId = parseInt(commingCompanyId);
        //console.log("companyId", companyId)
        fetchAllVersiondata(userId,pageIndex,pageSize)
            .then(response => {
                dispatch(getallversionsummary(response.data))
                setTable(response.data.data)
                setTotalCount(response.data.count);
                setOptions({
                    ...options,
                    pagination: {
                        pageSize: options.pagination.pageSize,
                        current: options.pagination.current,
                        total: response.data.count,
                        pageSizeOptions: ['50', '100'],
                        showSizeChanger: true,
                    }
                })
                setLoading(false)
                console.log("options",options)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });     
            setLoading(false)       
    }

    const getRoleDetails = () => {
        if (loggedUserId == null) {
            history.push("/");
        }
        fetchUserRoledata(loggedUserId)
            .then(response => {
                dispatch(getuserroleandmenu(response.data))
                if (response.data.data.userRoleDetails[0].roleId)                
                    setRoleId(response.data.data.userRoleDetails[0].roleId);                           
                //const _companyId = response.data.data.userRoleDetails[0].companyId;
               
                setCommingCompanyId(response.data.data.userRoleDetails[0].companyId); // Set the company ID in state
                console.log("comming CompanyId", commingCompanyId)
                //getBannerDetails(); 
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const handleChange = (pagination, sorter, current) => {
        const updatedOptions = { ...options, pagination };
        setOptions(updatedOptions);
        setPageData(updatedOptions)
    };
    useEffect(() => {              
        getVersionDetails();
    }, [commingCompanyId]);

    const handleReview = (Id) => {
        // var localurl = "https://localhost:44366/Workitem/Edit/" 
        var url = `/Workitem/Edit/`
       // var url = REACT_APP_WORLITEM_LINK
        //var win = window.open(url + Id, '_blank');
        history.push(url + Id);
        win.onload = function () {
            var targetElement = win.document.getElementById('version_summary');
            if (targetElement) {
                var targetPosition = targetElement.offsetTop;
                win.scrollTo(0, targetPosition);
            }
        };
    }

    const handleVersionChange = async (checked, record) => {
        if (record.workItemID) {
            const response = await axios.put(url.UPDATE_VERSIONSUMMARY, {
                WorkItemID: record.workItemID,
                IsApprovedSummary: checked,
            }).then(response => {
                dispatch(updateapprovedsummary(response.data))
                if (!response.data.success) // False 
                {
                    toast.error(t("Failedonversionupdate"), {
                        className: "toastSuccess",
                    },);
                }
                else {
                    toast.success((checked == true ? t("VersionSummarySuccessfullyApproved") : t("VersionSummaryDenied")), {
                        className: "toastSuccess",
                    },);
                    getVersionDetails(); 
                }
            })
                .catch((err) => {
                    console.log("Err: ", err);
                });
        }
    }

    const getFullDate = (date) => {
        const newDate = new Date(date);
        const returnDate = ((newDate.getMonth() > 8) ? (newDate.getMonth() + 1) : ('0' + (newDate.getMonth() + 1))) + '-' + ((newDate.getDate() > 9) ? newDate.getDate() : ('0' + newDate.getDate())) + '-' + newDate.getFullYear();
        const dateAndTime = date.split("T");
        const time = dateAndTime[1].split(":");
        const seconds = parseInt(time[2]);
        const newtime = time[0] + " : " + time[1] + " : " + seconds;
        const times = time[0] > 12 ? time[0] % 12 : time[0];
        const timeslatest = times < 9 ? ('0' + times) : times;
        const newtime1 = timeslatest + " : " + time[1] + " : " + seconds;
        if (time[0] && time[0] >= 12) {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime1 + " PM "
                returnDate + ", " + newtime1 + " PM "
            );
        } else {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime + " AM "
                returnDate + ", " + newtime + " AM "
            );
        }
    };

    const openWorkitemEdit = (id) => {
        history.push('/Workitem/Edit/' + id)
    };

    const WorkStatus = {
        0: "New",
        1: "Active",
        2: "Resolved",
        3: "ReOpen",
        4: "QA",
        5: "Deployed"
    };

    const columns = [
        {
            title: "Work Item ID",
            dataIndex: "workItemID",
            render: (value, item, index) => {
                const isEditable = roleId === 7;

                return (
                    <div className="d-flex align-items-center gap-2">
                        <Tooltip title={isEditable ? "Open Work Item" : ""}>
                            {isEditable ? (
                                <Link
                                    className="open-work-item-link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        openWorkitemEdit(item.workItemID);
                                    }}
                                >
                                    {item.workItemID}
                                </Link>
                            ) : (
                                <span className="work-item-id-static">
                                    {item.workItemID}
                                </span>
                            )}
                        </Tooltip>
                    </div>
                );
            },
        },


        {
            title: t("ProjectName"),
            dataIndex: "projectName",
        },

        {
            title: t("VersionSummary"),
            dataIndex: "versionSummary",
            className: "description_projects",
            render: (versionSummary) => {
                // Remove all occurrences of &nbsp; (non-breaking space)
                const cleanedSummary = versionSummary.replace(/&nbsp;/g, ''); 
                return <Tooltip title={cleanedSummary}>{cleanedSummary}</Tooltip>;
            },
           // render: (versionSummary) => <Tooltip title={versionSummary}>{versionSummary}</Tooltip>,
        },

        {
            title: t("Status"),
            dataIndex: "status",
            render: (status) => {
                const statusText = WorkStatus[status] || "";
                const statusClass = `status-${statusText.toLowerCase()}`; // Matches your CSS class names

                // Map status to corresponding icon
                const StatusIcon = {
                    0: NewReleasesIcon,
                    1: PlayArrowIcon,
                    2: CheckCircleIcon,
                    3: ReplayIcon,
                    4: BugReportIcon,
                    5: RocketLaunchIcon // Using Deployed icon since your CSS uses status-deployed
                    // 5: DoneAllIcon // Alternative for Closed if you switch back
                }[status] || null;

                return (
                    <span className={statusClass}>
                        {StatusIcon && <StatusIcon sx={{ fontSize: 16, marginRight: '4px', verticalAlign: 'middle' }} />}
                        {statusText}
                    </span>
                );
            },
        },

        {
            title: t("VersionDate"),
            dataIndex: "updatedDate",
            render: (updatedDate) => updatedDate ? getFullDate(updatedDate) : "",
        },
        {
            title: t("ApprovedSummaryDate"),
            dataIndex: "approvedSummaryDate",
            render: (approvedSummaryDate) => approvedSummaryDate ? getFullDate(approvedSummaryDate) : "",
        },
        ...(roleId === 7 ? [{
            title: t("Approve"),
            key: 'index',
            render: (text, record, index) => (
                <div className="alarm-toggle--wrap">
                    <Switch className="ms-2"
                        defaultChecked={record.isApprovedSummary}
                        onChange={(checked) => handleVersionChange(checked, record)}
                    />
                </div>
            ),
        }] : []),

        ...(roleId === 7 ? [{
            title: t("Review"),
            key: 'index',
            render: (data, companyId) => (<>
                <Tooltip title={t("ReviewVerisonSummary")}>
                
                    <VisibilityIcon style={{ color: '#FBAF5D',cursor: "pointer" }} fontSize="small" onClick={() => handleReview(data.workItemID)} />
                       
                </Tooltip>

            </>)
        }] : []),
    ]

    return (
        <div>
            <Title title="Version Summaries"></Title>
            {roleId == null ? <Loader /> : 
                <>
                    {loading ? <Loader /> : ''}
                    <Layout>
                        <section className="Company_section common ">
                            <Toaster />
                          
                            <div className="container banner-container">
                                <Breadcrumb style={{ margin: '20px 0 0 0', padding: '0px' }}
                                    itemRender={(route, params, routes, paths) => (
                                        route.path ? (
                                            <Link to={route.path}>
                                                {route.breadcrumbName}
                                            </Link>
                                        ) : (
                                            <span>{route.breadcrumbName}</span>
                                        )
                                    )}

                                    items={[
                                        {
                                            breadcrumbName: 'Dashboard',
                                            path: '/Dashboard',
                                        },
                                        {
                                            breadcrumbName: 'Settings',
                                            path: '',
                                        },
                                        {
                                            breadcrumbName: 'Version Summaries',
                                            path: '',
                                        }
                                    ]}
                                />

                                <div className=" w-100 position-relative wk-select d-flex gap-2 justify-content-between align-items-end">
                                    <h4 className="m-0">{t("Versions")}</h4>    
                                    <div class="notification-box">
                                        <p>* <strong>Version Summary:</strong> The app will be notified after approval and will remain active for the next 7 days.</p>
                                        <p>* <strong>Build Date:</strong> TEKaVerse will notify users after approval, and the notification will remain active for the next 7 days.</p>
                                    </div>
                                </div>
                                <div className="Viewer-table index--table position-relative common-table mb-4">
                                    <Table
                                        className="table-responsive antd--detail-table1"
                                        columns={columns}
                                        dataSource={table}
                                        pagination={
                                            showPagination
                                                ? {
                                                    current: options.pagination.current || 1,
                                                    pageSize: options.pagination.pageSize || 50,
                                                    total: options.pagination.total || 0,
                                                    showSizeChanger: true,
                                                    pageSizeOptions: ["50", "100"],
                                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                }
                                                : false
                                        }
                                        onChange={handleChange}
                                    />
                                </div>

                            </div>

                        </section>
                    </Layout>
                </>
            }
        </div>
    )

}
export default connect()(VersionIndex);